var $class="se2--header-se--search",$name="HeaderSE/search",$path="app/components/HeaderSE/partials/search/config.js",$this={$class,$name,$path,};export const globalSearchApcUrl = 'https://www.apc.com/static/js/global-search.js';
export const searchClassName = $class;
